import React from "react";
import House from "assets/icons/House.svg";
import { Toaster } from "react-hot-toast";
import CustomPagination from "../Pagination";
import { useNavigate } from "react-router-dom";
import Location from "assets/icons/Location.svg";
import LastPosted from "assets/icons/LastPosted.svg";
import { formatDateUS } from "../../../utils/FormatDate";
// Helper function to format date to YYYY-MM-DD format
// Local helper to convert enum-like strings (e.g., PROPERTY_GROUNDS) to human readable
const humanizeEnum = (value) => {
  if (!value || typeof value !== "string") return "";
  return value
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

const PropertiesCard = ({
  totalCount,
  offers,
  children,
  showPagination = true,
  btnText = "",
  currentPage,
  setCurrentPage,
  resultsPerPage,
  onResultsPerPageChange,
}) => {
  const navigate = useNavigate();

  const renderCard = (offer, idx) => {
    const cardId = offer.id ?? idx;

    return (
      <div
        key={cardId}
        className="w-full bg-[#FDFDFD] rounded-[16px] border border-[#ECECEC] p-4 shadow-sm flex flex-col md:gap-4 gap-2 h-full"
      >
        {typeof children === "function" ? children(offer, cardId) : <></>}
        <div className="flex justify-between items-start  sm2:flex-row flex-col gap-y-2">
          <div className="flex gap-4 items-center">
            <h3 className="font-medium text-[#242424]">{offer.name}</h3>
          </div>

          <span
            className={`text-[12px]  px-3 py-1 border rounded-full font-medium text-[#3CAB5C] bg-[#F2FBF4] border-[#3CAB5C]`}
          >
            • {offer.noOfActiveJobs} Active jobs
          </span>
        </div>

        <div className="text-sm text-gray-700 sm2:space-y-2 space-y-4 font-neue-haas flex-grow">
          <p className="flex sm2:flex-row flex-col justify-between sm2:items-center sm2:gap-10">
            <span className="flex items-center gap-2 font-medium md:text-[14px] text-nowrap text-[12px] text-[#595959] ">
              <img src={Location} className="w-4 h-4 " alt="Job Icon" /> Job
              Location:
            </span>
            <span className="  md:text-[14px] font-medium text-[12px]  text-[#242424]">
              {offer.streetAddress}
            </span>
          </p>
          <p className="flex sm2:flex-row flex-col justify-between sm2:items-center sm2:gap-10">
            <span className="flex items-center gap-2 font-medium md:text-[14px] text-[12px] text-[#595959] ">
              <img src={House} className="w-4 h-4 " alt="Star Icon" /> Property
              Type:
            </span>
            <span className="  md:text-[14px] font-medium font-neue-haas text-[12px]  text-[#242424]">
              {offer.propertyType}
            </span>
          </p>
          <p className="flex sm2:flex-row flex-col justify-between sm2:items-center sm2:gap-10">
            <span className="flex items-center gap-2 font-medium md:text-[14px] text-[12px] text-[#595959] ">
              <img src={LastPosted} className="w-4 h-4 ]" alt="Dollar Icon" />{" "}
              Last Job Posted:
            </span>
            <span className=" font-neue-haas md:text-[14px] text-[12px] font-medium  text-[#242424]">
              {humanizeEnum(offer.lastJobPosted?.issueType)}
              {offer.lastJobPosted?.subIssueType
                ? ` (${humanizeEnum(offer.lastJobPosted?.subIssueType)})`
                : ""} - {formatDateUS(offer.lastJobPosted?.createdAt)}
            </span>
          </p>
        </div>

        <div className="flex gap-4 w-full ">
          {btnText === "Post job at this address" ? (
            <button
              onClick={() =>
                navigate("/post-job", { state: { property: offer } })
              }
              className="rounded-[12px] border border-[#2C8D48] w-full bg-[#F2FBF4] text-center text-[16px] text-[#2C8D48] hover:bg-gray-100"
            >
              {" "}
              Post job at this address
            </button>
          ) : (
            <div className="flex gap-2 md:gap-5 w-full">
              {" "}
              <button className="bg-[#F8F8F8] w-full nowrap text-nowrap text-[12px]  md:text-[16px]  flex gap-2 items-center justify-center border-[#ECECEC] text-[#242424]  md:h-12  h-10   hover:bg-[#3c8f47]  p-2  md:p-3 sm:text-[14px] lg:text-[16px]    rounded-xl font-medium">
                View summary
              </button>
              <button className="bg-[#3cab5c] w-full text-nowrap flex gap-2   text-[12px]  md:text-[16px]  items-center justify-center md:h-12  h-10   hover:bg-[#3c8f47] text-white  md:p-3 p-2 sm:text-[14px] lg:text-[16px]   rounded-xl font-medium">
                Leave review
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4 gap-2 mb-4">
        {offers.map((offer, idx) => renderCard(offer, idx))}
      </div>
      <Toaster />
      {showPagination && (
        <CustomPagination
          totalCount={totalCount}
          resultsPerPage={resultsPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onResultsPerPageChange={onResultsPerPageChange}
          padding={false}
        />
      )}
    </>
  );
};

export default PropertiesCard;
